import { DATA } from './data';

export function uuid(): string {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  const charactersLength = characters.length;

  for (let i = 0; i < 12; i++) {
    const randomIndex = Math.floor(Math.random() * charactersLength);
    result += characters.charAt(randomIndex);
  }

  return result;
}

export function getRandomNumberBetween(min: number, max: number): number {
  return Math.random() * (max - min) + min;
}

export function getRandomIntegerBetween(min: number, max: number): number {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

export function formatNumber(num: number): string {
  const digits = 2;
  const suffixes = ['', 'K', 'M', 'B', 'T', 'P', 'E', 'Z', 'Y'];
  if (num === 0) return '0';
  const sign = Math.sign(num);
  num = Math.abs(num);

  // For numbers less than 1000, return them as is
  if (num < 1000) return (sign * num).toString();

  const tier = (Math.log10(num) / 3) | 0;
  const suffix = suffixes[tier];
  const scale = Math.pow(10, tier * 3);
  const scaled = num / scale;

  return (sign * scaled).toFixed(digits) + suffix;
}

export function niceRounding(num: number) {
  if (num === 0) return 0;
  const magnitude = Math.pow(10, Math.floor(Math.log10(num)) - 1);
  return Math.round(num / magnitude) * magnitude;
}

// [5, 100, 123, 1000, 1540, 123123, 1000000, 1000000000, 1200000000].forEach((num) => {
//   console.log(num, formatNumber(num));
// });

export function checkManyMoney() {
  if (window.location.href.includes('many_money')) {
    DATA.addMoney(10000000000);
    DATA.addTransportedPassangers(5000000);
  }
}

class Logger {
  log(...messages: any[]) {
    console.log('[AT]', ...messages);
  }
  error(...messages: any[]) {
    console.error('[AT]', ...messages);
  }
}

export const LOGGER = new Logger();
